<template>
    <div id="main">
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('criticas-despesas') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('despesas') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="$router.push({ name: 'des-critica-despesa' })"
                                        aria-current="page"
                                        >{{ $t('criticas-despesas') }}</a
                                    >
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar :onSearch="debouncedOnSearch" />
                    </div>
                </div>

                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="criticasDespesas"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'situacao' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{ 'excluir-field': f.key == 'situacao' }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'colaborador' && permissao.update">
                                <span
                                    v-if="
                                        props.row.motivoCritica == 'usuario-sem-empresa-associada'
                                    "
                                >
                                    <router-link
                                        :to="{
                                            name: 'des-edit-critica-despesas-empresa',
                                            params: { usuarioid: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </span>
                                <span v-else>
                                    <router-link
                                        :to="{
                                            name: 'des-edit-critica-despesas',
                                            params: {
                                                id: props.row.id,
                                                data: $moment(props.row.data).format('YYYY-MM-DD'),
                                            },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </span>
                            </div>
                            <div v-else-if="f.key == 'data'">
                                <div v-if="props.row.data == null">-</div>
                                <div v-else>
                                    <pre>{{ $moment(props.row[f.key]).format('DD/MM/YYYY') }}</pre>
                                </div>
                            </div>
                            <div v-else-if="f.key == 'motivo-critica'">
                                <span
                                    v-if="
                                        props.row.motivoCritica == 'usuario-sem-empresa-associada'
                                    "
                                >
                                    {{ $t(props.row.motivoCritica) }}
                                </span>
                                <span v-else>
                                    {{ mlGetMotivos(props.row.motivoCritica) }}
                                </span>
                            </div>

                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CriticasDespesasService from '@/services/despesas/CriticasDespesasService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            criticasDespesas: [],
            service: new CriticasDespesasService(this.$http, this.$router),
            fields: [
                { key: 'colaborador', width: null, sortable: true, sortFn: null },
                { key: 'motivo-critica', width: null, sortable: true, sortFn: null },
                { key: 'data', width: null, sortable: true, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: '',
            column: 'colaborador',
            order: 'asc',
            permissao: {},
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'despesas',
            'criticas-despesas',
            'criticas-despesas'
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'criticas-despesas' },
            });
        } else {
            // Seleciona o valor na posição do array de opções de paginação
            this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        mlGetMotivos(motivos) {
            let motivosTemp = motivos.split(',');
            let mensagem = '';

            motivosTemp.forEach((motivo) => {
                if (motivo.includes('usuario') && !mensagem.includes('Usuário')) {
                    mensagem += ' •' + this.$t('usuario');
                }
                if (motivo.includes('procliente')) {
                    mensagem += ' •' + this.$t('procliente');
                } else if (motivo.includes('cliente')) {
                    mensagem += ' •' + this.$t('cliente');
                } else if (motivo.includes('prolps')) {
                    mensagem += ' •' + this.$t('prolps');
                } else if (!mensagem.includes('Checkin')) {
                    mensagem += ' •' + this.$t('checkin');
                }
            });

            return this.$t('possivel-localizacao-incorreta-em-n', { n: mensagem });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.criticasDespesas = value;
                    this.isEmpty = this.criticasDespesas.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os acertos.');
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    id: m.usuario.idusuario,
                    colaborador: m.usuario.nome,
                    data: m.checkindatahora,
                    motivoCritica: m.motivoCritica,
                };
            });
            return list;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }
    .tipos-servicos .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }
    .tipos-servicos .search-and-filter {
        .search-bar {
            width: 100%;
            padding-right: 10px;
        }
        .filter-bar {
            width: 31%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
